import { useLoaderData } from 'react-router';

import type { Route } from './+types/terms-of-service';
import { LegalPage } from '~/pages/LegalPage';

export const loader = async ({ request }: Route.LoaderArgs) => {
  const response = await fetch(new URL('./terms-of-service.md', request.url));

  const markdown = await response.text();

  return { markdown };
};

export default function ViewTermsOfService() {
  const { markdown } = useLoaderData<{ markdown: string }>();

  return <LegalPage markdown={markdown} />;
}
